import { createSlice } from '@reduxjs/toolkit';
import { createTarget, fetchTarget, updateTarget } from './targetThunks';

const initialState = {
  data: {
    fromDate: '',
    toDate: '',
    workOrderItems: [],
    browseNodes: [],
  },
  isFetching: false,
  isUpdating: false,
  isCreating: false,
  fetchError: null,
  updateError: null,
  createError: null,
};

export const targetSlice = createSlice({
  name: 'target',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTarget.pending, (state) => {
        state.isFetching = true;
        state.fetchError = null;
      })
      .addCase(fetchTarget.fulfilled, (state, action) => {
        state.isFetching = false;
        state.fetchError = null;
        state.data = action.payload;
      })
      .addCase(fetchTarget.rejected, (state) => {
        state.isFetching = false;
        state.fetchError = 500;
      })
      .addCase(createTarget.pending, (state) => {
        state.isCreating = true;
        state.createError = null;
      })
      .addCase(createTarget.fulfilled, (state, action) => {
        state.isCreating = false;
        state.createError = null;
        state.data = action.payload?.data;
      })
      .addCase(createTarget.rejected, (state) => {
        state.isCreating = false;
        state.createError = 500;
      })
      .addCase(updateTarget.pending, (state) => {
        state.isUpdating = true;
        state.updateError = null;
      })
      .addCase(updateTarget.fulfilled, (state, action) => {
        state.isUpdating = false;
        state.updateError = null;
        state.data = action.payload?.data;
      })
      .addCase(updateTarget.rejected, (state) => {
        state.isUpdating = false;
        state.updateError = 500;
      });
  },
});

export default targetSlice.reducer;
